import { Component, OnInit, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";

@Component({
  selector: 'app-task-list-popup',
  templateUrl: './task-list-popup.component.html',
  styleUrls: ['./task-list-popup.component.scss']
})
export class TaskListPopupComponent implements OnInit {

  public module: any;
  public selectedModule: any;
  public tasks: any;
  constructor(
    public dialogRef: MatDialogRef<TaskListPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.module = data.moduleData.module[0];
   }

  ngOnInit(): void {
    console.log(this.module);
    this.selectedModule = this.module.module[0].application;
    this.tasks = this.module.module[0].task_list;
  }

  showTask(data) {
    this.selectedModule = data.application;
    this.tasks = data.task_list;
  }

  onClose() {
    this.dialogRef.close("");
  }
}

